/*
 * fixparser
 * https://gitlab.com/logotype/fixparser.git
 *
 * Copyright © 2022 fixparser.io
 * Released under Commercial license. Check LICENSE.md
 */
export enum SubscriptionRequestTypeEnum {
    Snapshot = 0,
    SnapshotPlusUpdates = 1,
    DisablePreviousSnapshotPlusUpdateRequest = 2,
}
